import menu from './menu-common'

export default {
  menu
}
